import { render, staticRenderFns } from "./VIP_set.vue?vue&type=template&id=2a40c331&scoped=true&"
import script from "./VIP_set.vue?vue&type=script&lang=js&"
export * from "./VIP_set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40c331",
  null
  
)

export default component.exports